<card-info-detail-v2
  class="content-detail"
  [showButton]="true"
  (viewMoreLessEvent)="onClickViewMoreLess($event)"
>
  <h2 title class="name" i18n="@@activitiesinformation_para_tener_en_cuenta">
    Para tener en cuenta
  </h2>
  <div static-info class="text">
    @for (text of arrayText; track $index) {
    <p>
      {{ text }}
    </p>
    }
  </div>
</card-info-detail-v2>
